import { Image as ImageIcon } from 'lucide-react';

import { cn } from './utils';


/**
 * Square media thumbnail with an ImageIcon fallback, matching the mobile card
 * frames. `size` is a Tailwind size utility (e.g. `size-13`) and `iconClassName`
 * sizes the fallback glyph. Shared by the Inventory/Listings mobile card
 * thumbnails (audit 6c313234).
 */
function Thumbnail({ src, alt, size = 'size-10', iconClassName = 'size-[18px]!', className }) {
  return (
    <span
      className={cn(
        'grid shrink-0 place-items-center overflow-hidden rounded-lg border border-hairline bg-surface-2',
        size,
        className,
      )}
    >
      {src
        ? <img alt={alt} src={src} className="size-full object-cover" />
        : <ImageIcon className={cn(iconClassName, 'text-ink-subtle')} />}
    </span>
  );
}

Thumbnail.displayName = 'Thumbnail';

export { Thumbnail };
export default Thumbnail;
